import React from 'react';

import { LoadingCard } from 'src/commons/components/Card';
import { Footer } from 'src/commons/components/Footer';
import { HiddenAlert } from 'src/commons/components/HiddenAlert';
import { Nav } from 'src/commons/components/Nav/Nav';
import { Page } from 'src/commons/components/Page';

export const ApplicationLoader = () => (
  <>
    <Nav loading />
    <Page>
      <HiddenAlert id="apply-loading-hidden-alert" alertText="loading" />
      <LoadingCard />
      <Footer />
    </Page>
  </>
);
